import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    overflowY: 'scroll',
    padding: theme.spacing(1),
  },
  scrollXContainer: {
    backgroundColor: theme?.designer?.toolBackgroundColor,
    borderRadius: theme.spacing(0.8),
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    overflowX: 'scroll',
    marginBottom: theme.spacing(1),
  },
  toolBox: {
    borderColor: theme?.designer?.toolIconColor,
  },
  toolIcon: {
    color: theme?.designer?.toolIconColor,
  },
  selectedTool: {
    backgroundColor: theme?.designer?.selectedToolBackgroundColor,
    borderColor: theme?.designer?.selectedToolBackgroundColor,
  },
  selectedToolIcon: {
    color: theme?.designer?.selectedToolIconColor,
  },
  seatBox: {
    flexDirection: 'column',
    marginRight: theme.spacing(1),
    '&:last-child': {
      marginRight: 0,
    },
  },
  gridBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme?.designer?.toolBorderColor,
    borderRadius: theme.spacing(0.8),
    cursor: 'pointer',
  },
  scrollYContainer: {
    minHeight: '65px',
    maxHeight: '195px',
    overflowY: 'scroll',
  },
  gridContainer: {
    backgroundColor: theme?.designer?.toolBackgroundColor,
    borderRadius: theme.spacing(0.8),
    display: 'flex',
    padding: theme.spacing(0.5),
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  imgs: {
    height: '50px',
    width: '50px',
  },
  selectedTxt: {
    fontWeight: 600,
  },
  placeholderTitle: {
    color: theme?.designer?.placeholderTitleColor,
    textAlign: 'center',
  },
  placeholderMsg: {
    color: theme?.designer?.textColor,
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
  placeholderPlusIcon: {
    height: '20px',
    width: '20px',
    backgroundColor: theme?.designer?.primaryButtonBackgroundColor,
    borderRadius: theme.spacing(0.5),
    margin: theme.spacing(1),
    color: theme?.designer?.primaryButtonTextColor,
  }
}));

export default useStyles;
